export default __webpack_public_path__ + "static/media/plus-icon.95961641.svg";